// extracted by css-extract-rspack-plugin
export default {"linkPreDocuments":"LinkPreDocuments_linkPreDocuments__ZGpby"};